import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "4",
  height: "14",
  viewBox: "0 0 4 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1.99992 10.3335C2.92042 10.3335 3.66659 11.0797 3.66659 12.0002C3.66659 12.9207 2.92042 13.6668 1.99992 13.6668C1.07942 13.6668 0.333252 12.9207 0.333252 12.0002C0.333252 11.0797 1.07942 10.3335 1.99992 10.3335ZM1.99992 5.3335C2.92042 5.3335 3.66659 6.07966 3.66659 7.00016C3.66659 7.92066 2.92042 8.66683 1.99992 8.66683C1.07942 8.66683 0.333252 7.92066 0.333252 7.00016C0.333252 6.07966 1.07942 5.3335 1.99992 5.3335ZM1.99992 0.333496C2.92042 0.333496 3.66659 1.0797 3.66659 2.00016C3.66659 2.92064 2.92042 3.66683 1.99992 3.66683C1.07942 3.66683 0.333252 2.92064 0.333252 2.00016C0.333252 1.07969 1.07942 0.333496 1.99992 0.333496Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}